import { Typography } from '@mui/material';
import React from 'react';
import { Row } from '.';
import { Svgs } from '../assets/svg';
import { useDeviceType } from '../hooks/useDeviceType';
import { StepSequences, StepHeaderType } from '../models/StepsHeaderData';

interface Props extends React.PropsWithChildren {
  style?: React.CSSProperties;
  activeStep: number;
  totalSteps: number;
  headerSteps?: StepHeaderType;
}

const StepsHeader: React.FC<Props> = ({
  activeStep,
  totalSteps,
  headerSteps = 'defaultOffboarding',
  ...rest
}) => {
  const { isMobile, isTablet, smDesktop, mdDesktop } = useDeviceType();
  const baseWidth = smDesktop || mdDesktop ? 15 : 10;
  const width = isMobile || isTablet ? '100%' : `${baseWidth * totalSteps}%`;
  const headers = StepSequences[headerSteps];

  return (
    <Row
      {...rest}
      style={{
        cursor: 'default',
        width: width,
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'center',
        ...rest.style,
      }}>
      {headers?.map((header, index) => {
        const isActive = activeStep === index + 1;

        return (
          <React.Fragment key={index}>
            {index !== 0 && <Svgs.IconStepper style={{ transform: 'scale(0.8)' }} />}

            <Typography
              color={isActive ? 'primary' : 'info.main'}
              variant={isActive ? 'h4' : 'p14'}
              textAlign='center'
              paddingRight={index === 0 && (smDesktop || mdDesktop) ? '5px' : ''}>
              {header}
            </Typography>
          </React.Fragment>
        );
      })}
    </Row>
  );
};

export default StepsHeader;
